import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter } from "react-router-dom";

import { AuthProvider } from "@/contexts/AuthContext";
import { ErrorBoundary } from "@/app/ErrorBoundary";
import { initTelegramWebApp, applyTelegramTheme } from "@/lib/telegram";
import { ConfirmProvider } from "@/ui";
import { UserProfileSheetProvider } from "@/features/users/UserProfileSheetProvider";
import { App } from "@/app/App";

import "@/styles/globals.css";

initTelegramWebApp();
applyTelegramTheme();

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      gcTime: 5 * 60_000,
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
});

const rootEl = document.getElementById("root");
if (!rootEl) throw new Error("#root not found");

createRoot(rootEl).render(
  <StrictMode>
    <ErrorBoundary>
      <QueryClientProvider client={queryClient}>
        <BrowserRouter>
          <AuthProvider>
            <ConfirmProvider>
              <UserProfileSheetProvider>
                <App />
              </UserProfileSheetProvider>
            </ConfirmProvider>
          </AuthProvider>
        </BrowserRouter>
      </QueryClientProvider>
    </ErrorBoundary>
  </StrictMode>
);
